import { render, staticRenderFns } from "./TakeActions.vue?vue&type=template&id=6245239a&"
import script from "./TakeActions.vue?vue&type=script&lang=ts&"
export * from "./TakeActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports